import React from 'react'
import { logo } from '../../icons/icons'

// Pilot: splash promo gated; set REACT_APP_ENABLE_SPLASH_PROMO=true to re-enable
const Splash = () => {
  return (
    <>
      <div className="h_100vh flex flex-col items-center justify-evenly bg_dark">
        <div>
          <img src={logo} className="w-[137px]" alt="" />
          <h1 className='text-center text-white mt-5 fs_18'>Back To Reality</h1>
        </div>
        <div class="spinner-container">
          <div class="spinner-ring">
            <div class="spinner-inner"></div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Splash
